import EmberRouter from '@ember/routing/router';
import config from 'linced-learners/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  // Routes from linced-common
  this.route('login');
  this.route('callback');
  this.route('login-failed');
  this.route('logout');
  this.route('logged-out');
  this.route('springboard');
  // END routes from linced-common

  this.route('home');
  this.route('my-profile');
  this.route('page', { path: '/pages/:page_id' }, function () {
    this.route('assessment', { path: '/assessments/:assessment_id' });
    this.route('unlinked-posts');
  });
  this.route('post', { path: '/pages/:page_id/posts/:post_id' });
  this.route('goal', { path: '/goal/:goal_id/' });
  this.route('goals', function () {
    this.route('plp');
  });
  this.route('student-notices', { path: '/home/student-notices' }, function () {
    this.route('notice', { path: '/:post_id' });
  });
  this.route('my-feed');

  // Default Route - Do not put routes beneath this one
  this.route('not-found', { path: '/*path' });
});
